<template>
  <div>
    <ods-dialog
      :title="title"
      :visible.sync="dialogError"
      :append-to-body="true"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      center
      width="500px">
      <img :src="require('@/assets/icons/picto_datos.svg')"
              alt="Error" class="picto-dato">
      <span>
        <p class="problemas-con-el-ser">{{ message }}</p>
      </span>
      <span slot="footer">
        <ods-button class="cancel-button"
          type="primary"
          @click="closeDialog">
          {{ labelCancelButton }}
        </ods-button>
      </span>
    </ods-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogGenericError',
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      required: true
    },
    dialogError: {
      type: Boolean,
      default: false
    },
    labelCancelButton: {
      type: String,
      default: function () { return 'Reintentar' }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('dialog-closed', false)
    }
  }
}
</script>

<style lang="scss" scoped>
 .dialog-text {
    margin-bottom: rem(20);
    font-size: rem(14);
 }

 .img--style {
   width: rem(70);
   height: rem(44);
   margin-top: rem(78);
 }

 .problemas-con-el-ser {
  height: 26px;
  color: #060E14;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 26px;
  text-align: center;
  padding-top: 25px;
 }

 .picto-datos {
    height: 68px;
    width: 114px;
 }
</style>
